import { render, staticRenderFns } from "./MoreLikeThis.vue?vue&type=template&id=24517061&scoped=true"
import script from "./MoreLikeThis.vue?vue&type=script&lang=js"
export * from "./MoreLikeThis.vue?vue&type=script&lang=js"
import style0 from "./MoreLikeThis.vue?vue&type=style&index=0&id=24517061&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24517061",
  null
  
)

export default component.exports